import { createAction, createReducer } from '@reduxjs/toolkit';
import { get } from 'lodash-es';

const Actions = {
  setMfOrders: 'setMfOrders',
  filterMfOrders: 'filterMfOrders',
  getfundOrderDetails: 'getfundOrderDetails',
  setFundOrderDetails: 'setFundOrderDetails',
  resetMfOrders: 'resetMfOrders',
  removeMfOrder: 'removeMfOrder',
  triggerInvestment: 'triggerInvestment',
};

// Actions
export const setMfOrders = createAction(Actions.setMfOrders);
export const filterMfOrders = createAction(Actions.filterMfOrders);
export const getfundOrderDetails = createAction(Actions.getfundOrderDetails);
export const setFundOrderDetails = createAction(Actions.setFundOrderDetails);
export const resetMfOrders = createAction(Actions.resetMfOrders);
export const removeMfOrder = createAction(Actions.removeMfOrder);
export const triggerInvestment = createAction(Actions.triggerInvestment);

export const getMfOrders = (state) => {
  const orders = get(state, "mfOrders", {});
  return orders;
};

const initialState = {
  mfOrders: {},
  fundOrderDetails: [],
};

export default createReducer(initialState, (builder) => {
  builder.addCase(setMfOrders, (state, action) => {
    state.mfOrders = { ...state.mfOrders, ...action.payload };
  });
  builder.addCase(filterMfOrders, (state, action) => {
    state.mfOrders = action.payload;
  });
  builder.addCase(setFundOrderDetails, (state, action) => {
    state.fundOrderDetails = action.payload;
  });
  builder.addCase(resetMfOrders, (state) => {
    return initialState;
  });
  builder.addCase(removeMfOrder, (state, action) => {
    const mfOrders = {...state.mfOrders};
    delete mfOrders[action.payload];
    state.mfOrders = mfOrders;
  });
});
